<template>
    <div>
        <Head title="歡迎光臨" />

        <div
            :key="'homepage_' + index"
            v-for="(component, index) in $page.props.components"
            class="my-10"
        >
            <template v-if="component.type == 'ad'">
                <Marquee :data-set="Ads" :group="component.group" />
            </template>

            <template v-if="component.type == 'pc'">
                <Carousel
                    :data-set="pc_items(component, component.random_order)"
                    :show-nav="true"
                    >{{ pc_title(component) }}</Carousel
                >
            </template>
        </div>
        <!-- <div class="my-10">
      <Marquee :data-set="Ads" group="1" />
    </div>

    <div class="my-10">
      <Marquee :data-set="Ads" group="2" />
    </div>

    <div class="my-10">
      <Carousel :data-set="$page.props.hot_products_1" :show-nav="true"
        >熱銷商品</Carousel
      >
    </div>

    <div class="my-10">
      <Carousel :data-set="$page.props.season_products_1">季節主打</Carousel>
    </div>

    <div class="my-10">
      <Carousel :data-set="$page.props.hot_products_2" :show-nav="true"
        >熱銷商品</Carousel
      >
    </div>

    <div class="my-10">
      <Carousel :data-set="$page.props.season_products_2">季節主打</Carousel>
    </div>

    <div class="my-10">
      <Marquee :data-set="Ads" group="3" />
    </div> -->
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Marquee from "./Components/Marquee";
import Carousel from "../Products/Components/Carousel";

export default {
    components: {
        Marquee,
        Carousel,
    },
    layout: Layout,
    data() {
        return {
            Ads: this.$page.props.ads,
            Pcs: this.$page.props.pcs,
        };
    },
    methods: {
        pc(component) {
            return this.Pcs.find((pc) => {
                return pc.group == component.group;
            });
        },
        pc_items(component) {
            return this.pc(component).product_info;
            //   if (this.pc(component).random_order == true) {
            //     return _.shuffle(this.pc(component).product_info);
            //   } else {
            //     return this.pc(component).product_info;
            //   }
        },
        pc_title(component) {
            return this.pc(component).title;
        },
    },
};
</script>

<style lang="postcss"></style>
